module.exports = __webpack_public_path__ + "static/media/CD-Dragon_spearclaws.dfd41efd.png";